import React, { useState, useRef, useEffect, Fragment } from "react";
import cssIf from "../../../scripts/helpers/class.add.if";
import prettyFloat from "../../../scripts/helpers/pretty.float";
import { CURRENCY, CURRENCY_SYMBOL, CoT_MODE, DEAL_MOVEMENT_TYPES, DEAL_PRICE_WATCH_MODE, DEAL_TYPES } from "../../../settings/constants";
import useGlobal from "../../../store";
import Button from "../button";

import { 
  
  calculateActualAmountPriceComissionOfDeal,
  calculateMovementPriceForConcreticResult
  
} from "../../../store/actions/deals";

import './transaction.scss';
import Movement from "./movement";
import twoDigitFormat from "../../../scripts/helpers/two.digit.format";
import { printDateTime } from "../../../scripts/helpers/date.time.now";

export const Transaction = ( props ) => {

  // TODO сохранение комментария из режима просмотра сделки из истории сделок
  // TODO удаление сделки из режима просмотра сделки из истории сделок
  // TODO кнопки для этого уже есть, осталось написать функции

  const [ globalState, globalActions ] = useGlobal();

  const { currency, comission_or_time } = globalState;

  const { popup, deals } = globalActions;

  const {
    
    viewMode = false, // false = открытая сделка, true = просмотр закрытой сделки
    id,
    name,
    type = false,
    result,
    movements = [],
    tariff_comission,
    price_watch_mode,
    initialComment = "",
    saveComment,
    setMaxAmount = () => {},
    actionBuy = () => {},
    actionSell = () => {},
    actionClose = () => {},
    actionRemoveMovement = () => {},
    actionRemoveDeal = () => {},
    actionRemoveMovements = () => {},

  } = props;

  let openDate = movements?.[ 0 ]?.date;  
  if ( typeof openDate === "string" ) { openDate = new Date( openDate ); }

  let closeDate = movements?.[ movements.length - 1 ]?.date;  
  if ( typeof closeDate === "string" ) { closeDate = new Date( closeDate ); }

  let openDealDatetime = ``;
  let closeDealDatetime = ``;

  let timeInsideDeal = `Время в сделке — `;

  if ( openDate ) {

    openDealDatetime =
      `Открыта: `
    + `${ twoDigitFormat( openDate.getDate() ) }.`
    + `${ twoDigitFormat( openDate.getMonth() + 1 ) }.`
    + `${ openDate.getFullYear() } · `
    + `${ twoDigitFormat( openDate.getHours() ) }:${ twoDigitFormat( openDate.getMinutes() ) }`

  }
  
  if ( closeDate ) {
    
    closeDealDatetime +=
    `Закрыта: `
    + `${ twoDigitFormat( closeDate.getDate() ) }.`
    + `${ twoDigitFormat( closeDate.getMonth() + 1 ) }.`
    + `${ closeDate.getFullYear() } · `
    + `${ twoDigitFormat( closeDate.getHours() ) }:${ twoDigitFormat( closeDate.getMinutes() ) }`

  }

  let timeInsideDealDiff = Date.parse( closeDate ) - Date.parse( openDate );

  // Преобразование времени в дни, часы, минуты и секунды
  let daysInDeal = Math.floor(timeInsideDealDiff / (1000 * 3600 * 24));
  let hoursInDeal = Math.floor((timeInsideDealDiff / (1000 * 3600)) % 24);
  let minutesInDeal = Math.floor((timeInsideDealDiff / 1000 / 60) % 60);
  let secondsInDeal = Math.floor((timeInsideDealDiff / 1000 ) % 60);

  if ( daysInDeal  > 0 ) { timeInsideDeal += `${ daysInDeal } дней, `; }

  if ( hoursInDeal > 0 ) { 

    timeInsideDeal += `${ hoursInDeal } час` 

    if ( hoursInDeal !== 1 && hoursInDeal !== 21 ) {

      timeInsideDeal += hoursInDeal > 1 && ( hoursInDeal < 5 || hoursInDeal >= 22 ) ? `a` : `ов`;

    }

    timeInsideDeal += ` `;

  }

  timeInsideDeal += `${ minutesInDeal } мин `;
  timeInsideDeal += `${ secondsInDeal } сек.`;

  const TYPE_NAME = {
    1: "лонг",
    2: "шорт",
  }

  const randomID = Math.random(1000,9999);
  const isMobile = window.innerWidth < 900;

  const [ amount, setAmount ] = useState("");
  const [ price, setPrice ] = useState("");
  const [ onePaperPrice, setOnePaperPrice ] = useState("");
  const [ commission, setCommission ] = useState("");
  const [ comment, setComment ] = useState( initialComment );

  const inputPrice = useRef( null );
  const inputAmount = useRef( null );
  const inputCommission = useRef( null );
  const inputOnePaperPrice = useRef( null );

  const [ preview, setPreview ] = useState( false );
  const [ showPreview, setShowPreview ] = useState( isMobile );
  
  const [ actualAmount, setActualAmount ] = useState("");
  const [ actualMiddle, setActualMiddle ] = useState("");
  
  const [ onePaperPriceForConcreticResult, setOnePaperPriceForConcreticResult ] = useState( 0 );
  const [ amountOfPapersForConcreticResult, setAmountOfPapersForConcreticResult ] = useState( 0 );

  const [ validateFields, setValidateFields ] = useState( false );

  const [ viewModeShowInputComment, setViewModeShowInputComment ] = useState( false );

  function calculateMiddle() {

    console.log(`${ printDateTime() } called Transaction calculateMiddle`);

    let m_amount = 0;
    let m_price = 0;

    movements.forEach( m => {
      
      if ( 
        ( type === DEAL_TYPES.LONG && m.type === DEAL_MOVEMENT_TYPES.BUY )
        ||
        ( type === DEAL_TYPES.SHORT && m.type === DEAL_MOVEMENT_TYPES.SELL )
      ) {

        m_amount += 1;
        m_price += m.price / m.amount;

      }
    
    });

    const middle = prettyFloat( m_price / m_amount );

    return middle;

  }

  useEffect(() => {

    console.log(`${ printDateTime() } called Transaction useEffect №1`);

    let haveNoPapers = movements.length === 0; 
    
    if ( movements.length !== 0 ) {

      const actualNumbers = calculateActualAmountPriceComissionOfDeal({ order_type: type, order_movements: movements });
      haveNoPapers = actualNumbers.amount === 0;

    }

    if ( haveNoPapers ) {

      setOnePaperPriceForConcreticResult( 0 );
      setAmountOfPapersForConcreticResult( 0 );

    } else {

      const oppfcr = calculateMovementPriceForConcreticResult({ 

        tariff_commission: tariff_comission, 
        order_type: type, 
        order_movements: movements, 
        wanted_result: globalState[`wanted_result_${ CURRENCY[ currency ] }`]
      
      });

      setOnePaperPriceForConcreticResult( oppfcr.price );
      setAmountOfPapersForConcreticResult( oppfcr.amount );

    }

  }, [ 
    
    movements, 
    tariff_comission,
    globalState.wanted_result_rub,
    globalState.wanted_result_cny,
    globalState.wanted_result_usd,
    globalState.wanted_result_eur
  
  ]);

  useEffect(() => {

    console.log(`${ printDateTime() } called Transaction useEffect №2`);

    if ( movements.length > 0 ) {

      const actual = calculateActualAmountPriceComissionOfDeal({ order_type: type, order_movements: movements });
      setActualAmount( actual.amount );
      setActualMiddle( calculateMiddle() );

      if ( props.amount < actual.amount ) { setMaxAmount( actual.amount ); }
    
    }

  }, [ movements.length ])

  useEffect(() => {
    
    console.log(`${ printDateTime() } called Transaction useEffect №3`);

    setCommission( price !== "" ? prettyFloat( price / 100 * tariff_comission ) : "" );
    setValidateFields( +amount.length > 0 && +price.length > 0 && +commission.length > 0 );

  }, [ price ]);
  
  useEffect(() => {
    
    console.log(`${ printDateTime() } called Transaction useEffect №4`);

    ( price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL && amount !== "" && amount > 0 && onePaperPrice !== ( +price / +amount ) ) && 
      setOnePaperPrice( prettyFloat( +price / +amount ) );

  }, [ price, amount, price_watch_mode ]);

  useEffect(() => {
    
    console.log(`${ printDateTime() } called Transaction useEffect №5`);

    ( price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER && amount !== "" && amount > 0 && price !== ( +onePaperPrice * +amount ) ) && 
      setPrice( prettyFloat( +onePaperPrice * +amount ) );

  }, [ onePaperPrice, amount, price_watch_mode ]);

  useEffect(() => {
    
    console.log(`${ printDateTime() } called Transaction useEffect №6`);

    ( amount !== "" && amount > 0 && onePaperPrice !== "" && onePaperPrice > 0 ) && 
      setPrice( prettyFloat( +onePaperPrice * +amount ) )

  }, [ amount ]);

  useEffect(() => {
    
    console.log(`${ printDateTime() } called Transaction useEffect №7`);

    setValidateFields( +amount > 0 && +price > 0 && +commission > 0 );

    if ( showPreview && +amount > 0 && +price > 0 && +commission > 0 ) {

      mouseEnterMovementButton( 

        type === DEAL_TYPES.LONG 

          ? DEAL_MOVEMENT_TYPES.SELL 
          : DEAL_MOVEMENT_TYPES.BUY 
          
      );
        
    }

  }, [ amount, commission, price ]);

  function clearInputs( clearComment = false ) {

    setPrice("");
    setAmount("");
    setCommission("");
    setOnePaperPrice("");
    clearComment && setComment("");

  }

  function addMovement( movement_type ) {

    const form = {

      transaction: id,
      type: movement_type,
      amount,
      price,
      commission,

    }

    if ( movement_type === DEAL_TYPES.LONG  ) { 
      
      if ( actualAmount - amount < 0 && type === DEAL_TYPES.SHORT ) {

        const errText = ``
          + `Нельзя закрыть сделку, выкупив больше акций чем было продано в шорт, `
          + `т.к. это приведёт к ошибке вычисления результата сделки. `
          + `Если вы перевернули позицию в лонг, укажите для выкупа `
          + `оставшееся количество торгового инструмента, после чего создайте новую сделку.`

        alert( errText );

        return;

      }

      actionBuy( form );  
    
    }

    if ( movement_type === DEAL_TYPES.SHORT ) { 

      if ( actualAmount - amount < 0 && type === DEAL_TYPES.LONG ) {

        const errText = ``
          + `Нельзя закрыть сделку, продав больше акций чем было куплено в лонг, `
          + `т.к. это приведёт к ошибке вычисления результата сделки. `
          + `Если вы перевернули позицию в шорт, укажите для продажи `
          + `оставшееся количество торгового инструмента, после чего создайте новую сделку.`

        alert( errText );

        return;

      }
      
      actionSell( form ); 
    
    }

    clearInputs();

  }

  async function mouseEnterMovementButton( type ) {

    const form = {

      transaction: id,
      type,
      amount,
      price,
      commission,
      actualAmountOfDeal: actualAmount

    }

    let result = 0;

    if ( type === DEAL_TYPES.LONG  ) { result = await actionBuy( form, false, false );  }
    if ( type === DEAL_TYPES.SHORT ) { result = await actionSell( form, false, false ); }

    setPreview( result )
    setShowPreview( true );

  }

  function mouseLeaveMovementButton() {

    if ( isMobile ) { return; }
    
    setTimeout(() => { setPreview("") }, 200);
    setShowPreview( false );

  }

  function actionCloseCard( saveToHistory, closeCard ) {

    actionClose( saveToHistory, closeCard, id );
    clearInputs( true );

  }

  function actionClearCard() {

    actionRemoveMovements( id );
    clearInputs( true );

  }

  return (

    <div className = "transaction_container">

      <div className={`transaction ${ cssIf( viewMode, `transaction--view-mode` ) }`}>

        <div className = "title_container_tr">

          <div className = "title">

            { name } { type ? <span> - { TYPE_NAME[ type ]}</span> : "" }

          </div>

          { ( movements.length > 0 && actualAmount === 0 ) &&
            
            <div className = {`result ${ cssIf( result !== null && result.toString().indexOf('-') !== -1, 'result--minus' )}`}>

              { result }{ CURRENCY_SYMBOL[ currency ] }

            </div>
            
          }

        </div>

        { movements.length > 0 &&
        
          <div className = "col_names">

            <div className = "transaction_col1 flex-1">Тип</div>
            <div className = "transaction_col2 text-center">Кол-во</div>
            <div className = "transaction_col3 text-right">
              
              <span className = "desktop">Цена </span>за { price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL ? "все" : "х1" }

            </div>

            <div 
            
              className = "transaction_col4 text-right"
              onClick = { deals.toggleCommissionOrTimeMode }
              
            >

              { comission_or_time === CoT_MODE.COMISSION ? "Комисcия" : "Время" }

            </div>

          </div>

        }

        <div className = "row_container">

          { movements.length > 0 
          
            ? movements.map(( el, key ) => (

              <Movement

                id = { el.id }
                key = { key }
                type = { el.type }
                date = { el.date }
                price = { el.price }
                amount = { el.amount }
                commission = { el.commission }
                price_watch_mode = { price_watch_mode }
                comission_or_time = { comission_or_time }
                currency = { CURRENCY_SYMBOL[ currency ] }
                dealType = { type }
                actialAmountOfDeal = { actualAmount }
                actionRemove = { ( mID ) => actionRemoveMovement({ transaction: id, movement_id: mID }) }

                setAmount = { ( val ) => { 
                  
                  setAmount( val );

                  price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER

                    ? inputOnePaperPrice.current.focus()
                    : inputPrice.current.focus(); 
                
                }}

                setPrice = {( val ) => { 
                  
                  if ( price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER ) {

                    setOnePaperPrice( val );
                    inputOnePaperPrice.current.focus(); 

                  } else {

                    setPrice( val );
                    inputPrice.current.focus(); 

                  }
                
                }}

              />            

            ))

            : <p className = "tip text-center">Ваше первое действие по инструменту:</p>

          }

        </div>

        <div className = "block">

          { !viewMode ? 
          
            <Fragment>

              <div className = "col_names">

                <div>Кол-во акций</div>

                <div>
                  Цена { price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL ? "сделки" : "акции" }
                </div>

                <div>Комисcия</div>

              </div>

              <div className = "input_block">

                <input 
                  
                  ref = { inputAmount }
                  type = "text"
                  value = { amount }

                  onChange = {( e ) => {

                    const value = 
                      e.target.value
                        .toString()
                        .replace(",",".")
                        .replace(" ", ".")
                        .replace("b", "")
                        .replace("и", "")
                        .replace("s", "")
                        .replace("ы", "")

                    setAmount( value );
                  
                  }}

                  onKeyUp = {( e ) => {

                    switch ( e.key ) {

                      case "b": addMovement( DEAL_TYPES.LONG ); break;
                      case "s": addMovement( DEAL_TYPES.SHORT );  break;
                      default: break;

                    }

                    e.preventDefault();

                  }}

                  onContextMenu = { e => {

                    const lastMovement = movements?.[ 0 ];                        
                    movements.length > 0 && setOnePaperPrice( lastMovement.price / lastMovement.amount );
                    e.preventDefault();

                  }}

                />
                
                { price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL
                
                  ? <input 
                    
                      ref = { inputPrice }
                      type = "text"
                      value = { price }

                      onChange = { ( e ) => { 
                        
                        const value = 
                          e.target.value
                            .toString()
                            .replace(",",".")
                            .replace(" ", ".")
                            .replace("b", "")
                            .replace("и", "")
                            .replace("s", "")
                            .replace("ы", "")

                        setPrice( value );
                      
                      }}
                      
                      onClick = { ( e ) => {

                        ( amount === "" && actualAmount !== "" && actualAmount > 0 ) && setAmount( actualAmount );
                      
                      }}

                      onKeyUp = { ( e ) => {

                        console.log(e)

                        switch ( e.key ) {

                          case "b": addMovement( DEAL_TYPES.LONG ); break;
                          case "и": addMovement( DEAL_TYPES.LONG ); break;
                          case "s": addMovement( DEAL_TYPES.SHORT );  break;
                          case "ы": addMovement( DEAL_TYPES.SHORT );  break;
                          default: break;

                        }

                        e.preventDefault();

                      }}

                      onContextMenu = { e => {

                        const lastMovement = movements?.[ movements.length - 1 ];                        
                        movements.length > 0 && setPrice( lastMovement.price );
                        e.preventDefault();

                      }}

                    />

                  : price_watch_mode === DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER

                  ? <input 
                      
                      ref = { inputOnePaperPrice }
                      type = "text"
                      value = { onePaperPrice }
                      onChange = { ( e ) => { 
                        
                        const value = 
                          e.target.value
                            .toString()
                            .replace(",",".")
                            .replace(" ", ".")
                            .replace("b", "")
                            .replace("и", "")
                            .replace("s", "")
                            .replace("ы", "")

                        setOnePaperPrice( value );
                      
                      }}

                      onClick = { ( e ) => {

                        ( amount === "" && actualAmount !== "" && actualAmount > 0 ) && setAmount( actualAmount ) 
                        
                        console.log(`click`, e);


                        if ( e.type === 'contextmenu' && movements > 0 ) {

                          const lastMovement = movements?.[ movements.length - 1 ];
                          setOnePaperPrice( lastMovement.price / lastMovement.amount );

                        }

                      }}

                      onKeyUp = { ( e ) => {

                        console.log(e)

                        switch ( e.key ) {

                          case "b": addMovement( DEAL_TYPES.LONG  );  break;
                          case "и": addMovement( DEAL_TYPES.LONG  );  break;
                          case "s": addMovement( DEAL_TYPES.SHORT );  break;
                          case "ы": addMovement( DEAL_TYPES.SHORT );  break;
                          default: break;

                        }

                        e.preventDefault();

                      }}                      

                      onContextMenu = { e => {

                        const lastMovement = movements?.[ movements.length - 1 ];                        
                        movements.length > 0 && setOnePaperPrice( lastMovement.price / lastMovement.amount );
                        e.preventDefault();

                      }}

                    />

                  : <Fragment />
                  
                }

                <input 
                  
                  type  = "text"
                  value = { commission }
                  ref   = { inputCommission }

                  onChange = {( e ) => {

                    const value = 
                      e.target.value
                        .toString()
                        .replace(",",".")
                        .replace(" ", ".")
                        .replace("b", "")
                        .replace("и", "")
                        .replace("s", "")
                        .replace("ы", "")

                    setCommission( value );
                
                  }}

                  onKeyUp = {( e ) => {

                    switch ( e.key ) {

                      case "b": addMovement( DEAL_TYPES.LONG  );  break;
                      case "и": addMovement( DEAL_TYPES.LONG  );  break;
                      case "s": addMovement( DEAL_TYPES.SHORT );  break;
                      case "ы": addMovement( DEAL_TYPES.SHORT );  break;
                      default: break;

                    }

                    e.preventDefault();

                  }}

                />


              </div>

              {( movements.length > 1 && actualAmount > 0 ) && 
              
                <div className = "transaction__manymovements_stats">

                  <div className = "col_names">

                    <div>Сейчас акций</div>
                    <div style={{cursor: 'default'}}>Средняя</div>
                    <div style={{opacity: '0'}}></div>

                  </div>

                  <div className = "input_block">

                    <input 
                      type = "text"
                      value = { actualAmount }
                      onClick = {( e ) => setAmount( actualAmount ) }
                    />
                    
                    <input 
                      type = "text"
                      value = { actualMiddle }
                    />

                    <input 
                      style={{opacity: '0'}}
                      type = "text"
                      value = { commission }
                    />


                  </div>

                </div>
                
              }

              <div className = "button_block">

                <div className = "subblock button_block--movement-actions">

                  <Button
            
                    text = "Покупка"
                    color = "green"
                    action = { () => addMovement( DEAL_TYPES.LONG ) }
                    disabled = { !validateFields }
                    mouseEnter = { () => type !== DEAL_TYPES.LONG && mouseEnterMovementButton( DEAL_TYPES.LONG ) }
                    mouseLeave = { () => type !== DEAL_TYPES.LONG && mouseLeaveMovementButton() }

                  />

                  <Button
            
                    text = "Продажа"
                    color = "red"
                    action = { () => addMovement( DEAL_TYPES.SHORT ) }
                    disabled = { !validateFields }
                    mouseEnter = { () => type !== DEAL_TYPES.SHORT && mouseEnterMovementButton( DEAL_TYPES.SHORT ) }
                    mouseLeave = { () => type !== DEAL_TYPES.SHORT && mouseLeaveMovementButton() }

                  />

                </div>
                            
                <div 
                  className = "col_names col_preview" 
                  id = {`preview${ randomID }`} 
                  style = {
                    ( amount !== "" && price !== "" && commission !== "" && movements.length > 0 && showPreview )
                    ? { height: `30px`, opacity: `1` }
                    : {}
                  }
                >

                  <div>Произойдёт следующее:</div>
                  <div className={`result ${ cssIf( preview?.toString().indexOf('-') !== -1, 'result--minus' )}`}>{ preview } { CURRENCY_SYMBOL[ currency ] }</div>

                </div>


                { onePaperPriceForConcreticResult !== 0 && <hr className = "hr_fullframe" /> }

                
                { result < globalState[`wanted_result_${ CURRENCY[ currency ] }`] &&

                  <Fragment>

                    <div 
                      className = "col_names col_preview col_preview_wanted_result" 
                      id = {`preview${ randomID }`} 
                      style = {
                        ( onePaperPriceForConcreticResult !== 0 )
                        ? { height: `30px`, opacity: `1` }
                        : {}
                      }
                    >


                      <div title = {`Цена 1 акции, чтобы выйти в ${ globalState[`wanted_result_${ CURRENCY[ currency ] }`] } ${ CURRENCY_SYMBOL[ currency ] }`}>
                        Выйти в { globalState[`wanted_result_${ CURRENCY[ currency ] }`] } { CURRENCY_SYMBOL[ currency ] }:
                      </div>
                    

                      <div 
                      
                        className={`result`}
                        title = {`Цена одной акции, чтобы ${ type === DEAL_TYPES.LONG ? "продать" : "выкупить" } все акции`}
                        onClick={() => {
                          
                          if ( movements.length > 0 ) {

                            setAmount( amountOfPapersForConcreticResult ) 
                            setPrice( prettyFloat( ( onePaperPriceForConcreticResult * amountOfPapersForConcreticResult ) ) ) 
                            setOnePaperPrice( prettyFloat( onePaperPriceForConcreticResult ) );

                          }
                          
                        }}
                        
                      >
                      
                        { onePaperPriceForConcreticResult } { CURRENCY_SYMBOL[ currency ] }
                        
                      </div>

                    </div>

                  </Fragment>

                }

                <hr className = "hr_fullframe" /> 

                <div className = "comment_block input_block col_names flex-col">

                  <input 

                    type = "text"
                    value = { comment }
                    placeholder = "Комментарий к сделке"
                    onChange = { ( e ) => setComment( e.target.value ) }
                    onBlur = { () => saveComment( comment ) }

                  />

                </div>
                
                <hr className = "hr_fullframe" />
                
                { movements.length > 1 && 
                
                  <Fragment>
                  
                    <div className = "flex button_block--movement-actions" style={{ marginBottom: "16px" }}>

                      <Button
                
                        text = "Закрыть"
                        color = "blue"
                        action = { () => actionCloseCard( true, true ) }
                        disabled = { movements.length === 0 }

                      />

                      <Button
                
                        text = "Очистить"
                        color = "blue"
                        action = { () => actionCloseCard( true, false ) }
                        disabled = { movements.length === 0 }

                      />

                    </div>

                  </Fragment>

                }

                <Button
                  
                  text = { movements.length === 0 ? "Удалить карточку" : <Fragment>Очистить поля <span className = "desktop">без сохранения</span></Fragment> }
                  color = "blue"
                  action = { () => {

                    movements.length === 0 
                      ? actionCloseCard( false, true ) 
                      : actionClearCard()
                  
                  }}

                />
              
              </div>

            </Fragment>

          : <Fragment>
            
              <div className = "button_block">              

                <div className = "comment_block input_block col_names flex-col">

                  { !viewModeShowInputComment
                  
                    ? <p 
                        className = "pointer"
                        onClick = { () => setViewModeShowInputComment( true ) }
                        title = "Редактировать комментарий"
                      >

                        {( comment && comment !== "" )
                          ? comment
                          : "Написать комментарий" 
                        }

                      </p>
                  
                    : <input 

                        type = "text"
                        value = { comment }
                        placeholder = "Комментарий к сделке"
                        onChange = { ( e ) => setComment( e.target.value ) }
                        onBlur = { () => {
                          
                          saveComment( comment );
                          setViewModeShowInputComment( false );
                          
                        }}

                      />
                    
                  }

                </div>

                <hr className = "hr_fullframe" />

                { viewMode && 
                
                  <Fragment>
                    
                    <div className = "comment_block flex justify-center">{ openDealDatetime }<br/><br/></div>
                    <div className = "comment_block flex justify-center">{ closeDealDatetime }<br/><br/></div>
                    <div className = "comment_block flex justify-center">{ timeInsideDeal }<br/><br/></div>

                  </Fragment> 
                  
                }

                <div>

                  <Button
                    
                    text = { <Fragment>Закрыть <span className = "desktop">модальное</span> окно</Fragment>}
                    color = "blue"
                    action = { () => { popup.hide() }}

                  />

                </div>

                <br/>

                <Button
                  
                  text = "Удалить сделку"
                  color = "red"
                  action = { () => {

                    actionRemoveDeal( id )
                  
                  }}

                />

              </div>

            </Fragment> 
            
          }

        </div>

      </div>
      
    </div>

  );

}

export const AddTransaction = ({ action, centerred = false }) => {

  const inputRef = useRef();
  const [ showInput, setShowInput ] = useState( false );
  const [ name, setName ] = useState("");


  function clearAndClose() {

    setName("");
    setShowInput( false );
    
  }
 
  function handleAdd() { 

    if ( showInput && name.length > 0 ) {      

      action( name ); //TODO pass id too
      clearAndClose();

    } else {

      showInput && alert("Название не может быть пустым!");

    }

  }

  function handleOpen() {

    if ( !showInput ) { 

      setShowInput( true );
      setTimeout(() => { inputRef.current.focus(); }, 100 );
    
    }

  }

  function handleKeyUp( e ) {

    if ( e.key === "Enter" ) { handleAdd(); }
    else if ( e.key === "Escape" ) { clearAndClose(); }

  }
  
  return (

    <div 

      id = "transaction_add_anchor"
      onClick = { handleOpen } 
      className = {`transaction_add ${ cssIf( centerred, `transaction_add--centerred` ) } relative`}
      title = { !showInput ? "Открыть новую сделку" : null }

    >
      
      <div className = "title_container">

        { showInput

          ? <input

              ref = { inputRef }
              type="text" 
              value = { name }
              className = "title"
              placeholder = "Название"
              onChange = { e => setName( e.target.value ) }
              onKeyUp = { handleKeyUp }

            />

          : <div className = "title">Новая сделка</div>
          
        }

        <div onClick = { handleAdd } className = "anchor">+</div>

      </div>

    </div>
    
  );

}